// client/src/pages/UserReports/components/DraggablePoint.js
// Enskild draggable punkt på tidslinjen — används av Recovery's
// RecoveryTimelineSlider. Tooltips hanteras av slidern, inte här.
import React, { useState } from 'react';
const DraggablePoint = ({
  id,
  type,
  date,
  symptoms = [],
  position, // Left percentage (0-100)
  color,
  isDragging = false,
  onDragStart,
  onDrag,
  onDragEnd
}) => {
  
  // ========== STATE MANAGEMENT ==========
  const [isHovered, setIsHovered] = useState(false);
  // REMOVED: const [showTooltip, setShowTooltip] = useState(false);
  
  // ========== TYPE CONFIGURATIONS ==========
  const typeConfig = {
    insjuknande: {
      icon: '🔴',
      label: 'Insjuknande',
      description: 'När symptomen började'
    },
    nya_symptom: {
      icon: '🟡', 
      label: 'Nya symptom',
      description: 'Ytterligare symptom tillkom'
    },
    frisk: {
      icon: '🟢',
      label: 'Frisk',
      description: 'Helt återställd'
    }
  };
  
  const config = typeConfig[type] || typeConfig.insjuknande;
  
  // ========== DRAG HANDLERS ==========
  const handleMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (onDragStart) {
      onDragStart(id, e.clientX);
    }
  };
  
  // ========== RENDER ==========
  return (
    <div
      className={`draggable-point ${type} ${isDragging ? 'dragging' : ''} ${isHovered ? 'hovered' : ''}`}
      style={{ 
        left: `${position}%`,
        zIndex: isDragging ? 1000 : (isHovered ? 100 : 10)
      }}
      onMouseDown={handleMouseDown}
      onMouseEnter={() => {
        setIsHovered(true);
        // REMOVED: setShowTooltip(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
        // REMOVED: setShowTooltip(false);
      }}
    >
      
      {/* Point Circle */}
      <div 
        className="point-circle"
        style={{ backgroundColor: color }}
      >
        <span className="point-icon" role="img" aria-label={config.label}>
          {config.icon}
        </span>
      </div>
      
      {/* Connector Line to Timeline */}
      <div className="point-connector"></div>
      
      {/* REMOVED: Tooltip - TimelineSlider hanterar nu alla tooltips */}
      
      {/* Enhanced CSS UTAN TOOLTIP */}
      <style jsx>{`
        .draggable-point {
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          cursor: grab;
          transition: all 0.2s ease;
          user-select: none;
        }
        
        .draggable-point.dragging {
          cursor: grabbing;
          transform: translate(-50%, -50%) scale(1.2);
          z-index: 1000;
        }
        
        .draggable-point.hovered {
          transform: translate(-50%, -50%) scale(1.1);
        }
        
        .draggable-point.dragging .point-circle {
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
        }
        
        .point-circle {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 3px solid white;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          transition: all 0.2s ease;
          position: relative;
        }
        
        .draggable-point.hovered .point-circle {
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
          border-width: 4px;
        }
        
        .point-icon {
          font-size: 10px;
          line-height: 1;
          filter: brightness(1.2);
        }
        
        .point-connector {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 2px;
          height: 30px;
          background: rgba(0, 0, 0, 0.1);
          z-index: -1;
        }
        
        /* Type-specific styling */
        .draggable-point.insjuknande .point-circle {
          background-color: #e74c3c;
        }
        
        .draggable-point.nya_symptom .point-circle {
          background-color: #f39c12;
        }
        
        .draggable-point.frisk .point-circle {
          background-color: #27ae60;
        }
        
        .draggable-point.insjuknande.hovered .point-circle {
          background-color: #c0392b;
        }
        
        .draggable-point.nya_symptom.hovered .point-circle {
          background-color: #e67e22;
        }
        
        .draggable-point.frisk.hovered .point-circle {
          background-color: #229954;
        }
        
        /* REMOVED: All tooltip CSS - TimelineSlider handles tooltips now */
        
        /* Responsive Adjustments */
        @media (max-width: 768px) {
          .point-circle {
            width: 18px;
            height: 18px;
            border-width: 2px;
          }
          
          .draggable-point.hovered .point-circle {
            border-width: 3px;
          }
          
          .point-icon {
            font-size: 9px;
          }
        }
        
        /* Accessibility */
        @media (prefers-reduced-motion: reduce) {
          .draggable-point,
          .point-circle,
          .draggable-point.hovered,
          .draggable-point.dragging {
            transition: none;
          }
        }
        
        /* Touch Device Optimizations */
        @media (hover: none) and (pointer: coarse) {
          .draggable-point {
            cursor: pointer;
          }
          
          .draggable-point.dragging {
            cursor: pointer;
          }
          
          .point-circle {
            width: 24px;
            height: 24px;
          }
        }
      `}</style>
      
    </div>
  );
};

export default DraggablePoint;